var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"bg-gray-800"},[_c('px-header'),_c('router-view',{staticClass:"container sm:px-20 py-20 flex justify-center"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }